import styled from '@emotion/styled/macro';

export const StyledDotsContainer = styled('div')`
    position: absolute;
    bottom: 15px;

    display: block;

    width: 100%;
    padding: 0;
    margin: 0;

    list-style: none;

    text-align: center;
`;

export const StyledDot = styled('button')`
`;

export const StyledDotContainer = styled('li')`
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    margin: 0 5px;
    padding: 0;
    cursor: pointer;

    ${StyledDot} {
        font-size: 0;
        line-height: 0;
        display: block;
        width: 20px;
        height: 20px;
        padding: 5px;
        cursor: pointer;
        color: transparent;
        border: 0;
        outline: none;
        background: transparent;

        &::before {
            font-size: 32px;
            line-height: 20px;
            position: absolute;
            top: 0;
            left: 0;
            width: 20px;
            height: 20px;
            content: '•';
            text-align: center;
            opacity: .25;
            color: white;
            transition: font-size .35s;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }
    }

    &.active {
        ${StyledDot} {
            &::before {
                opacity: .75;
                color: white;
            }
        }
    }

    &.small {
        ${StyledDot} {
            &::before {
                font-size: 18px;
            }
        }
    }
`;
